import { render, staticRenderFns } from "./SysMsg.vue?vue&type=template&id=978af62e&scoped=true"
import script from "./SysMsg.vue?vue&type=script&lang=js"
export * from "./SysMsg.vue?vue&type=script&lang=js"
import style0 from "./SysMsg.vue?vue&type=style&index=0&id=978af62e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "978af62e",
  null
  
)

export default component.exports